import { useState } from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import useT from "utils/useT"
import Form from "./Form"
import SocialLinks from "components/SocialLinks"
import SuccessCard from "./SuccessCard"

export const Search = () => {
  const t = useT()
  const [success, setSuccess] = useState(false)
  const NEXT_PUBLIC_RECAPTCHA_SITE_KEY =
    process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }}
    >
      <div className="card card-style mb-3">
        <div className="content">
          <p dir="auto">{t.contact.hero}</p>
        </div>
      </div>
      {success ? (
        <SuccessCard setSuccess={setSuccess} />
      ) : (
        <Form setSuccess={setSuccess} />
      )}
      <SocialLinks />
    </GoogleReCaptchaProvider>
  )
}
export default Search
